document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('rebuy:smartcart.show', (event) => {
    document.querySelectorAll('.rebuy-cart__flyout-item-discount-message').forEach(item => {
      item.style.display = 'none';
    });
    addDiscountPercent();
  });
});


function addDiscountPercent() {
    document.querySelectorAll('.percentage-off').forEach(item => {
      item.remove();
    });
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cart.items.forEach(item => {
          const discountAlloc = item.line_level_discount_allocations?.[0]?.discount_application;
          if (discountAlloc?.value_type === 'percentage' && item.properties['_rc_bundle']) {
            const discountValue = parseInt(discountAlloc.value);
  
            const bundleItem = document.querySelectorAll(`.product-${item.handle}[class*="property-_rc_bundle"]`);
            
            if (bundleItem) {
              const compareAtPrice = bundleItem[0].querySelectorAll('.rebuy-cart__flyout-item-price');
              const spanPercentage = document.createElement('span');
              spanPercentage.textContent = ` ${discountValue}% OFF`; 
              const span = document.createElement('span');
              span.classList.add('sale', 'percentage-off');
              span.appendChild(spanPercentage);
              compareAtPrice[0].firstElementChild.appendChild(span);
            }
          }
        });
      })
      .catch(error => {
        console.error('Error:', error);
      });
}



function patchCompareAt(sc) {
  if (!sc || typeof sc.compareAtPrice !== 'function' || sc.__tvgCompareFix) return;

  const orig = sc.compareAtPrice;

  sc.compareAtPrice = function(item) {
    const v = orig.apply(this, arguments);

    if (typeof v === 'string' && v.trim() !== '') {
      const n = parseFloat(v);
      return isNaN(n) ? v : Math.round(n * 100);   // "140.00" → 14000
    }
    return v;
  };

  sc.__tvgCompareFix = true;
}
(function waitForSmartCart() {
  let tries = 0;
  const timer = setInterval(function() {
    const sc = window.Rebuy && window.Rebuy.SmartCart;

    if (sc && typeof sc.compareAtPrice === 'function') {
      patchCompareAt(sc);

      if (sc.view && sc.view.$forceUpdate) sc.view.$forceUpdate();

      clearInterval(timer);
    } else if (++tries > 120) {
      clearInterval(timer);
    }
  }, 250);
})();


// SUBSCRIPTION UPDATE ISSUE FIX IN THE CART DRAWER

const tvgLivePlans = {};
const tvgProductCache = {};

function getLiveProduct(handle) {
  if (!tvgProductCache[handle]) {
    tvgProductCache[handle] = fetch('/products/' + handle + '.js')
      .then(r => r.ok ? r.json() : null)
      .then(p => {
        if (!p) return null;

        const names = {};
        (p.selling_plan_groups || []).forEach(g =>
          (g.selling_plans || []).forEach(sp => { names[sp.id] = sp.name; })
        );

        (p.variants || []).forEach(v => {
          tvgLivePlans[String(v.id)] = (v.selling_plan_allocations || []).map(a => ({
            id: a.selling_plan_id,
            name: names[a.selling_plan_id] || ''
          }));
        });
        return p;
      })
      .catch(() => null);
  }
  return tvgProductCache[handle];
}

function refreshLivePlans() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => Promise.all([...new Set(cart.items.map(i => i.handle))].map(getLiveProduct)))
    .then(() => {
      const sc = window.Rebuy && window.Rebuy.SmartCart;
      if (sc && sc.view && sc.view.$forceUpdate) sc.view.$forceUpdate();
    })
    .catch(() => {});
}

function patchSwitchToSubscription(sc) {
  if (!sc || typeof sc.hasSwitchToSubscription !== 'function' || sc.__tvgSubFix) return;

  const orig = sc.hasSwitchToSubscription; 
  sc.hasSwitchToSubscription = function(item) {
    const ok = orig.apply(this, arguments); 
    if (!ok || !item) return ok;

    const live = tvgLivePlans[String(item.variant_id || item.id)];
    if (live && live.length === 0) return false;
    return ok;
  };
  sc.__tvgSubFix = true;
}

function resolvePlan(lineKey, requestedPlanId) {
  return fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const line = cart.items.find(i => i.key === lineKey || String(i.id) === String(lineKey));
      if (!line) return requestedPlanId;

      return getLiveProduct(line.handle).then(() => {
        const live = tvgLivePlans[String(line.variant_id)] || [];
        if (!live.length) return requestedPlanId;

        if (live.some(p => String(p.id) === String(requestedPlanId))) return requestedPlanId;

        let wantedName = '';
        const sc = window.Rebuy && window.Rebuy.SmartCart;
        const rItem = sc && sc.items && sc.items().find(i => i.key === line.key);
        const groups = rItem && rItem.product && rItem.product.selling_plan_groups;
        (groups || []).forEach(g => (g.selling_plans || []).forEach(sp => {
          if (String(sp.id) === String(requestedPlanId)) wantedName = sp.name;
        }));

        const byName = wantedName && live.find(p => p.name.toLowerCase() === wantedName.toLowerCase());
        return (byName || live[0]).id;
      });
    })
    .catch(() => requestedPlanId);
}

(function patchFetchForSubscriptionSwitch() {
  if (window.__tvgFetchSubFix) return;
  window.__tvgFetchSubFix = true;
  const nativeFetch = window.fetch;

  window.fetch = function(input, init) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';

      const rawBody = init && init.body;
      const wasParams = typeof URLSearchParams !== 'undefined' && rawBody instanceof URLSearchParams;
      const body = typeof rawBody === 'string' ? rawBody : (wasParams ? rawBody.toString() : null);

      if (/\/cart\/change(\.js)?/.test(url) && body && body.indexOf('selling_plan') > -1) {
        const isJson = body.trim().charAt(0) === '{';
        let key, plan, data, params;

        if (isJson) {
          data = JSON.parse(body);
          key = data.id || data.line;
          plan = data.selling_plan;
        } else {
          params = new URLSearchParams(body);
          key = params.get('id') || params.get('line');
          plan = params.get('selling_plan');
        }

        if (key && plan) {
          return resolvePlan(key, plan).then(newPlan => {
            if (String(newPlan) !== String(plan)) {
              if (isJson) {
                data.selling_plan = Number(newPlan);
                init = Object.assign({}, init, { body: JSON.stringify(data) });
              } else {
                params.set('selling_plan', newPlan);
                init = Object.assign({}, init, { body: wasParams ? params : params.toString() });
              }
            }
            return nativeFetch.call(window, input, init);
          });
        }
      }
    } catch (e) {
      console.warn('[tvg] subscription switch patch skipped:', e);
    }
    return nativeFetch.apply(this, arguments);
  };
})();

document.addEventListener('rebuy:smartcart.show', refreshLivePlans);
document.addEventListener('rebuy:cart.change', refreshLivePlans);

(function waitForSmartCartSub() {
  let tries = 0;
  const timer = setInterval(function() {
    const sc = window.Rebuy && window.Rebuy.SmartCart;
    if (sc && typeof sc.hasSwitchToSubscription === 'function') {
      patchSwitchToSubscription(sc);
      refreshLivePlans();
      clearInterval(timer);
    } else if (++tries > 120) {
      clearInterval(timer);
    }
  }, 250);
})();